// extracted by mini-css-extract-plugin
var _1 = "ra-wall-preview";
var _2 = "ra-wall-preview-wall-img";
var _3 = "ra-wall-preview-label";
var _4 = "ra-wall-preview-person";
var _5 = "ra-wall-preview-wrapper";
export { _1 as "artWallCls", _2 as "artWallImageWrapperCls", _3 as "artWallLabelCls", _4 as "artWallPersonCls", _5 as "artWallWrapperCls" }
